/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HeartIcon20Solid = forwardRef('HeartIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.495 7.7C1.495 5.106 3.45 3 6.048 3c1.53 0 3.34.914 3.947 2.734C10.603 3.914 12.413 3 13.943 3c2.599 0 4.552 2.105 4.552 4.7 0 2.987-2.556 5.01-4.532 6.894-.724.69-1.545 1.473-2.464 2.376a2.15 2.15 0 0 1-3.007 0c-.92-.903-1.74-1.685-2.464-2.376-1.977-1.883-4.533-3.907-4.533-6.893Z" })));
});
